import { ArrowForward, NavigateBefore } from "@mui/icons-material";
import { Box, Button, Divider, Grid, IconButton } from "@mui/material";
import React, { useState } from "react";
import { colors } from "../../theme/colors";
import { ContentWrapper, StyledTitle } from "./styled";
import { Field, Form } from "react-final-form";
import BITextFieldForm from "../../components/common/Forms/TextField/TextField";
import {
  composeValidators,
  onlyText,
  phoneNumber,
  required,
  validateEmail,
} from "../../utils/validators";

export default function Beneficiarie({
  prevStep,
  nextStep,
  beneficiarie,
  updateBeneficiarie,
}) {
  const [buttonHover, setButtonHover] = useState(false);

  const enviarDatosOperacionales = (formValues) => {
    const payload = {
      transaction: {
        category: "oky",
        type: "beneficiary details",
        details: formValues,
      },
      accountTo: {
        clientRefIdStr: `${formValues.name} ${formValues.surname}`,
        phoneNumber: formValues.phone,
        email: formValues.email,
      },
    };

    fetch(`${process.env.REACT_APP_SMARTID}/reportOperation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {})
      .catch((error) => {
        console.warn("Error en fetch:", error.message);
      });
  };

  const handleSubmit = (formProps) => {
    updateBeneficiarie(formProps);
    enviarDatosOperacionales(formProps);
    nextStep();
  };

  return (
    <>
      <div style={{ maxWidth: "85%", margin: "auto" }}>
        <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />

        <Box display={{ xs: "none", sm: "block" }}>
          <Grid
            container
            justifyContent="center"
            spacing={2}
            alignItems="center"
          >
            <Grid item>
              <IconButton onClick={prevStep}>
                <NavigateBefore
                  sx={{ color: colors.secondary, fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
            <Grid item lg={5} sm={7} xl={4}>
              <StyledTitle>Datos de beneficiario</StyledTitle>
            </Grid>
          </Grid>
        </Box>

        <Box display={{ xs: "block", sm: "none" }}>
          <Grid
            container
            justifyContent="center"
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={1}>
              <IconButton onClick={prevStep}>
                <NavigateBefore
                  sx={{ color: colors.secondary, fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
            <Grid item xs={11}>
              <StyledTitle>Datos de beneficiario</StyledTitle>
            </Grid>
          </Grid>
        </Box>
      </div>

      <ContentWrapper>
        <Form onSubmit={handleSubmit} initialValues={beneficiarie}>
          {(formProps) => (
            <form
              noValidate
              autoComplete="none"
              onSubmit={formProps.handleSubmit}
            >
              <Grid container columnSpacing={3} rowSpacing={4}>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="name"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Nombre"
                    required
                    placeholder="Nombre"
                    validate={composeValidators(required, onlyText())}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="surname"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Apellido"
                    required
                    placeholder="Apellido"
                    validate={composeValidators(required, onlyText())}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="phone"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Teléfono"
                    required
                    placeholder="Teléfono"
                    validate={composeValidators(required, phoneNumber())}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="email"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Correo electrónico (opcional)"
                    placeholder="Ingresa correo electrónico"
                    validate={validateEmail()}
                  />
                </Grid>
              </Grid>

              <Button
                endIcon={
                  buttonHover ? <ArrowForward color="secondary" /> : null
                }
                onMouseOver={() => setButtonHover(true)}
                onMouseOut={() => setButtonHover(false)}
                color={buttonHover ? "primary" : "secondary"}
                variant="contained"
                style={{
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100%",
                  paddingRight: buttonHover ? "10%" : "initial",
                  transition: "padding 200ms",
                  paddingTop: "0.5rem",
                  paddingBottom: "0.5rem",
                  marginTop: "3rem",
                  maxWidth: "650px",
                }}
                type="submit"
              >
                Siguiente
              </Button>
            </form>
          )}
        </Form>
      </ContentWrapper>
    </>
  );
}
